import { render } from "./LogoComp.vue?vue&type=template&id=a22a7bc0&scoped=true"
import script from "./LogoComp.vue?vue&type=script&lang=js"
export * from "./LogoComp.vue?vue&type=script&lang=js"

import "./LogoComp.vue?vue&type=style&index=0&id=a22a7bc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22a7bc0"]])

export default __exports__